import React from "react";
import Lv3SelectOptionBtn from "./Lv3SelectOptionBtn";
import Lv3SelectOptionBtnGrey from "./Lv3SelectOptionBtnGrey";
import LengthWeightDisableBtn from "./LengthWeightDisableBtn";
import { connect } from "react-redux";
import product from "../../../../models/product";
import getArrWithAvaliable from "../../../../function/getArrWithAvaliable";
import SubOptionsLv3ExtraDescription from "./SubOptionsLv3ExtraDescription";

// CSS
import "../../../../css/WeightSection.css";

class SubOptionLv3Section extends React.Component {
  componentDidMount() {
    const { ui, activeOptionIndex, changeLv3SelectOptionDefault } = this.props;
    const lv3OptionDefault = ui.options[activeOptionIndex].option.defaultShow;

    if (lv3OptionDefault === undefined) return;
    changeLv3SelectOptionDefault(lv3OptionDefault.lv3Code);
  }

  componentDidUpdate = () => {
    const {
      isClick,
      subOptionLv3List,
      changeLv3SelectOptionDefault,
      ui,
      activeOptionIndex
    } = this.props;
    const lv3OptionDefault = ui.options[activeOptionIndex].option.defaultShow;

    let lv3Default;

    if (isClick) {
      // 傳第一筆資料;
      lv3Default =
        (subOptionLv3List.hasOwnProperty("subitems") &&
          subOptionLv3List.subitems[0].code) ||
        "";
    } else {
      //傳預設值
      lv3Default = (lv3OptionDefault && lv3OptionDefault.lv3Code) || "";
    }
    changeLv3SelectOptionDefault(lv3Default);
  };
  render() {
    const { subOptionLv3List, subOptionLv3DisplayList } = this.props;
    const title = subOptionLv3DisplayList.title;
    let component;
    let subitemslength =
      (subOptionLv3List.subitems && subOptionLv3List.subitems.length) || 0;

    if (
      subOptionLv3List.hasOwnProperty("subitems") &&
      subOptionLv3DisplayList.hasOwnProperty("subitems")
    ) {
      const arrayWithAvaliable = getArrWithAvaliable(
        subOptionLv3DisplayList.subitems,
        subOptionLv3List.subitems
      );
      component = arrayWithAvaliable.map((item, index) => {
        if (item.status === "available") {
          return (
            <Lv3SelectOptionBtn
              key={index}
              index={index}
              name={item.name}
              code={item.code}
              type="lv3"
              className="option-btn"
            />
          );
        } else if (item.status === "outOfStock") {
          return (
            <Lv3SelectOptionBtnGrey
              key={index}
              index={index}
              name={item.name}
              code={item.code}
              type="lv3"
              className="option-btn"
            />
          );
        }
        return (
          <LengthWeightDisableBtn
            className="option-btn"
            key={index}
            name={item.name}
          />
        );
      });
    }

    return subitemslength >= 1 && subOptionLv3DisplayList.subitems ? (
      <div className="detailsSection ringMeasure_wrap small-txt-link-wrap">
        <p className="subtitle">
          <span style={{ textTransform: "capitalize" }}>{title}</span>
        </p>
        <div id="lv3Section" className="optionBoxes">
          {component}
          <SubOptionsLv3ExtraDescription />
        </div>
      </div>
    ) : (
      ""
    );
  }
}

const mapStateToProps = state => {
  return {
    subOptionLv3DisplayList: state.product.subOptionLv3DisplayList,
    subOptionLv3List: state.product.subOptionLv3List,
    isClick: state.product.isLv2Click,
    ui: state.product.ui,
    activeOptionIndex: state.product.activeOptionIndex
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeLv3SelectOptionDefault: data =>
      product.actions.changeLv3SelectOptionDefault(data)
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubOptionLv3Section);
